import { render, staticRenderFns } from "./DienstleisterAlert.vue?vue&type=template&id=57878420&scoped=true&"
import script from "./DienstleisterAlert.vue?vue&type=script&lang=ts&"
export * from "./DienstleisterAlert.vue?vue&type=script&lang=ts&"
import style0 from "./DienstleisterAlert.vue?vue&type=style&index=0&id=57878420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57878420",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
